import { previewModeKey, previewModeRegex } from '../../constants'
import getPreviewMode from '../../utils/getPreviewMode'
import removePreviewModeFromUrl from '../../utils/removePreviewModeFromUrl'

function usePreviewMode(url) {
  const href = (typeof window === 'object' && window.location?.href) || url

  const isPreviewMode = href && previewModeRegex.test(href)
  const value = href && getPreviewMode(href)

  function onDeactivateClick() {
    document.cookie = `${previewModeKey}=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/;`
    window.location.href = removePreviewModeFromUrl(href)
  }

  return { isPreviewMode, value, onDeactivateClick }
}

export default usePreviewMode
